(function () {
  document.querySelectorAll('[data-product-page]').forEach(function (page) {
    var productScript = page.querySelector('[data-product-json]');
    var form = page.querySelector('[data-product-form]');
    if (!productScript || !form) return;
    var product = JSON.parse(productScript.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var submit = form.querySelector('[data-add-to-cart]');
    var price = page.querySelector('[data-price]');
    var stickyPrice = page.querySelector('[data-sticky-price]');

    function selectedOptions() {
      return product.options.map(function (name, index) {
        var checked = form.querySelector('input[data-option-position="' + (index + 1) + '"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    function renderVariant(variant) {
      if (!variant) {
        submit.disabled = true;
        submit.textContent = window.FabreciaTheme.strings.unavailable;
        return;
      }
      idInput.value = variant.id;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? window.FabreciaTheme.strings.addToCart : window.FabreciaTheme.strings.soldOut;
      if (price) {
        var compare = variant.compare_at_price && variant.compare_at_price > variant.price ? '<s class="price__compare">' + window.Fabrecia.formatMoney(variant.compare_at_price) + '</s><span class="price__badge">' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF</span>' : '';
        price.innerHTML = '<span class="price__regular">' + window.Fabrecia.formatMoney(variant.price) + '</span>' + compare;
        price.classList.toggle('price--on-sale', Boolean(compare));
      }
      if (stickyPrice) stickyPrice.textContent = window.Fabrecia.formatMoney(variant.price);
      if (variant.featured_media) {
        var thumb = page.querySelector('[data-gallery-thumb="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    form.addEventListener('change', function (event) {
      var input = event.target.closest('input[data-option-position]');
      if (!input) return;
      form.querySelectorAll('input[name="' + input.name + '"]').forEach(function (radio) {
        radio.closest('.variant-pill').classList.toggle('is-selected', radio.checked);
      });
      renderVariant(findVariant(selectedOptions()));
    });

    page.querySelectorAll('[data-sticky-add]').forEach(function (button) {
      button.addEventListener('click', function () {
        submit.click();
      });
    });
  });
})();
